module.exports = __webpack_public_path__ + "static/img/icon_onnenpyora.72334aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_onnenpyora.png
// module id = 5Kt3
// module chunks = 1